import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchBookingValues } from '../../../redux/actions/CreateBookingAction';
import { useIntl } from 'react-intl';
import useTime from '../../../hooks/useTime';
import busOrdersApi from '../../../api/bus_orders';
import { orderStatus } from '../order_status.type';
import { paymentStatus } from '../payment.type';
import { paymentMethod } from '../pay.method';
import CountryData from '../../../utils/countrydata';
const HTTP_STATUS_CONFLICT_CODE = 600;
const { Title } = Typography;
const { Option } = Select;

const PassengerInfo = (props) => {
  const {
    segment,
    isOpenPassenger,
    setIsOpenPassenger,
    setIsShowPassenger,
    onRefresh,
    onModalFormClose,
    currentData,
    paxQty,
    index_edit_passenger,
  } = props;
  console.log('index_edit_passenger', index_edit_passenger);
  const intl = useIntl();
  const { formatAsISOString, convertToAnyTimezone } = useTime();
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const searchValues = useSelector(
    (state) => state.createBookings.searchValues
  );

  const departure = useSelector((state) => state.createBookings.departure);
  const returnDestination = useSelector((state) => state.createBookings.return);

  const [payMethods, setPaymentMethods] = useState(null);
  const [payMethod, setPaymentMethod] = useState('');

  const onChangePaymentMethod = (e) => {
    console.log('radio checked', e.target.value);
    setPaymentMethod(e.target.value);
  };
  console.log('currentData', currentData);
  const onClosePassenger = () => {
    setIsOpenPassenger(false);
  };

  const handleSavePassengers = (values) => {
    console.log('values', values, index_edit_passenger);
    if (values.passengers && values.passengers.length > 0) {
      if (currentData || index_edit_passenger) {
        const updatedPassengers = [...(searchValues.passengers || [])];
        updatedPassengers[index_edit_passenger] = {
          ...values.passengers[0],
          id: updatedPassengers[index_edit_passenger].id,
        };
        console.log('updatedPassengers', updatedPassengers);
        dispatch(
          updateSearchBookingValues({
            passengers: updatedPassengers,
          })
        );
      } else {
        dispatch(
          updateSearchBookingValues({
            passengers: values.passengers,
          })
        );
      }
      setIsOpenPassenger(false);
      setIsShowPassenger && setIsShowPassenger(true);
      message.success('add passengers successfully!');
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [form]);

  console.log('payMethods', payMethods);
  const [passenger, setPassenger] = useState(null);
  const [indexPassenger, setIndexPassenger] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const fetchCustomerByPhone = async (phone, index) => {
    try {
      const res = await busOrdersApi.getPassenger(phone);
      if (res) {
        setPassenger(res);
        setIndexPassenger(index);
        setOpenModal(true);
      }
      // Xử lý dữ liệu tại đây (cập nhật form, hiển thị thông tin...)
    } catch (error) {
      console.error('Lỗi khi gọi API:', error);
      setOpenModal(false);
    }
  };
  const handleSelectPassenger = () => {
    console.log('handleSelectPassenger', indexPassenger, passenger);
    if (indexPassenger === null || !passenger) return;
    console.log('handleSelectPassenger');

    // Tách số điện thoại
    let phoneCode = '';
    let phoneNumber = '';

    if (passenger.phone?.startsWith('221')) {
      phoneCode = '221';
      phoneNumber = passenger.phone.slice(3);
    } else {
      phoneNumber = passenger.phone;
    }
    console.log('phoneCode', phoneCode, phoneNumber);
    // Set vào form
    form.setFieldValue(
      ['passengers', indexPassenger, 'firstname'],
      passenger.firstname
    );
    form.setFieldValue(
      ['passengers', indexPassenger, 'lastname'],
      passenger.lastname
    );
    form.setFieldValue(
      ['passengers', indexPassenger, 'passport'],
      passenger.passport
    );
    form.setFieldValue(['passengers', indexPassenger, 'mobile'], phoneNumber);
    form.setFieldValue(
      ['passengers', indexPassenger, 'phone_code'],
      `+${phoneCode}`
    );
    setOpenModal(false);
  };

  return (
    <>
      <Drawer
        title={<IntlMessage id="global.passengers" />}
        width={'45%'}
        onClose={onClosePassenger}
        open={isOpenPassenger}>
        <Form
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          form={form}
          name="control-hooks"
          initialValues={{
            passengers: [],
          }}
          onFinish={handleSavePassengers}
          style={{ maxWidth: 1000 }}>
          {paxQty &&
            new Array(paxQty).fill(0).map((item, i) => {
              let firstCustomerIndex;
              let firstPassengerInfo = {
                firstname: null,
                lastname: null,
                passport: null,
                phone_code: '+221',
                mobile: null,
              };
              console.log('searchValues', searchValues);
              if (
                searchValues?.passengers &&
                searchValues?.passengers.length > 0
              ) {
                firstCustomerIndex = i;
                console.log('firstCustomerIndex', firstCustomerIndex);
                firstPassengerInfo.firstname =
                  searchValues?.passengers?.[
                    index_edit_passenger ? index_edit_passenger : i
                  ]?.firstname ?? '';
                firstPassengerInfo.lastname =
                  searchValues?.passengers?.[
                    index_edit_passenger ? index_edit_passenger : i
                  ]?.lastname ?? '';
                firstPassengerInfo.mobile =
                  searchValues?.passengers?.[
                    index_edit_passenger ? index_edit_passenger : i
                  ]?.mobile ?? '';
                firstPassengerInfo.phone_code =
                  searchValues?.passengers?.[
                    index_edit_passenger ? index_edit_passenger : i
                  ]?.phone_code ?? '';
                firstPassengerInfo.passport =
                  searchValues?.passengers?.[
                    index_edit_passenger ? index_edit_passenger : i
                  ]?.passport ?? '';
              }
              return (
                <>
                  <Title level={5}>Passenger {i + 1}</Title>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Form.Item
                        label={<IntlMessage id="global.phone_code" />}
                        name={['passengers', i, 'phone_code']}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.phone_code
                            : '+221'
                        }>
                        <Select
                          style={{ width: '100%' }}
                          placeholder="Select phone code"
                          showSearch
                          defaultValue={`+221`}
                          options={CountryData.map((country, i) => {
                            return {
                              label: `(+${country.code}) ${country.country}`,
                              value: `+${country.code}`,
                            };
                          })}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item
                        label={<IntlMessage id="global.phone" />}
                        name={['passengers', i, 'mobile']}
                        rules={[
                          {
                            required: true,
                            message: <IntlMessage id="global.requiredfield" />,
                          },
                          {
                            message: <IntlMessage id={`global.numberfield`} />,
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.mobile
                            : ''
                        }>
                        <Input
                          onBlur={(e) => {
                            const phone = e.target.value;
                            if (/^[0-9]+$/.test(phone)) {
                              // Gọi API tại đây
                              fetchCustomerByPhone(phone, i);
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    label={<IntlMessage id="global.firstname" />}
                    name={['passengers', i, 'firstname']}
                    initialValue={
                      firstCustomerIndex === i
                        ? firstPassengerInfo.firstname
                        : ''
                    }
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label={<IntlMessage id="global.lastname" />}
                    name={['passengers', i, 'lastname']}
                    initialValue={
                      firstCustomerIndex === i
                        ? firstPassengerInfo.lastname
                        : ''
                    }
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={<IntlMessage id="global.passport" />}
                    name={['passengers', i, 'passport']}
                    initialValue={
                      firstCustomerIndex === i
                        ? firstPassengerInfo.passport
                        : ''
                    }
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <Input />
                  </Form.Item>
                </>
              );
            })}
          {/* <div>Choose payment method</div>
        <Radio.Group
          style={{ width: '100%' }}
          onChange={onChangePaymentMethod}
          value={payMethod}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {payMethods &&
              payMethods.length > 0 &&
              payMethods.map((item) => {
                return (
                  <>
                    <Radio value={item.method}>{item?.display}</Radio>
                    {payMethod === item.method && (
                      <Row gutter={[8, 8]}>
                        <Col span={8}>
                          <Form.Item name={'phone_code'} initialValue={'+221'}>
                            <Select
                              style={{ width: '100%' }}
                              placeholder="Select phone code"
                              showSearch
                              defaultValue={`+221`}
                              options={CountryData.map((country, i) => {
                                return {
                                  label: `(+${country.code}) ${country.country}`,
                                  value: `+${country.code}`,
                                };
                              })}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={16}>
                          <Form.Item
                            name={'mobile'}
                            rules={[
                              {
                                required: true,
                                message: (
                                  <IntlMessage id="global.requiredfield" />
                                ),
                              },
                              {
                                message: (
                                  <IntlMessage id={`global.numberfield`} />
                                ),
                                pattern: new RegExp(/^[0-9]+$/),
                              },
                            ]}>
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                  </>
                );
              })}

            <Radio value={'pay_later'}>Pay later</Radio>
          </Space>
        </Radio.Group>

        <Form.Item
          label={<IntlMessage id="global.notes" />}
          name="notes"
          style={{ marginTop: 20 }}>
          <Input.TextArea
            placeholder={intl.formatMessage({
              id: 'global.input_order_notes',
            })}
            rows={4}
          />
        </Form.Item> */}
          <Button
            htmlType="submit"
            loading={isLoadingSave}
            style={{
              background: '#14bb8c',
              color: '#FFF',
              cursor: 'pointer',
            }}>
            <IntlMessage id="customer.create" />
          </Button>
        </Form>
      </Drawer>
      <Modal
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={null}>
        {passenger ? (
          <>
            <Card style={{ cursor: 'pointer' }} onClick={handleSelectPassenger}>
              <Row gutter={16}>
                <Col span={12}>
                  <strong>
                    {passenger.firstname} {passenger.lastname}
                  </strong>{' '}
                </Col>
                <Col span={12}>{passenger.phone}</Col>
              </Row>
            </Card>
          </>
        ) : (
          <p>load...</p>
        )}
      </Modal>
    </>
  );
};

export default PassengerInfo;
